/* eslint-disable no-console */
import { useEffect, useRef } from 'react';
import { phoneNumbersLooselyMatch } from '../../../../util/phoneNumber';
import createFonemaCallEvent from '../utils/fonemaCallEventService';

/**
 * Hook specifically to handle the onAnswer event from the Fonema SDK.
 * It is responsible for setting the active call and creating the call event in the backend.
 */
const useFonemaOnAnswer = ({ callInfoData, startActiveCall, enabled = true }) => {
  const callInfoDataRef = useRef(callInfoData);
  callInfoDataRef.current = callInfoData;
  const startActiveCallRef = useRef(startActiveCall);
  startActiveCallRef.current = startActiveCall;

  useEffect(() => {
    if (!enabled) return undefined;

    let unsubscribeAnswer;

    if (window.FonemaWhatsappAudio?.onAnswer) {
      console.log('Setting up onAnswer listener in useFonemaOnAnswer');
      unsubscribeAnswer = window.FonemaWhatsappAudio.onAnswer((callData) => {
        console.log('Call answered:', callData);
        const sameCallId = callInfoDataRef.current.callId === callData.callId;
        const sameCaller = phoneNumbersLooselyMatch(
          callInfoDataRef.current.callerNumber,
          callData.callerNumber
        );
        if (sameCallId || sameCaller) {
          startActiveCallRef.current({
            ...callInfoDataRef.current,
            callId: callData.callId
          });

          createFonemaCallEvent({
            callData: {
              ...callInfoDataRef.current,
              callId: callData.callId
            },
            customerId: callInfoDataRef.current.customer?.id
          });

          if (typeof window.handleFonemaIncomingCallAnswered === 'function') {
            window.handleFonemaIncomingCallAnswered();
          }
        }
      });
    }

    return () => {
      console.log('Cleaning up onAnswer listener in useFonemaOnAnswer');
      if (unsubscribeAnswer && typeof unsubscribeAnswer === 'function') {
        console.log('Unsubscribing from onAnswer event');
        unsubscribeAnswer();
      }
    };
  }, [callInfoDataRef, startActiveCallRef, enabled]);
};

export default useFonemaOnAnswer;
